
module.directive('studentEmailValidator', function($q, ModelService) {
    return {
        require: '?ngModel',
        scope: {student: '=studentEmailValidator'},
        link: function(scope, element, attrs, ngModel) {
            if (!ngModel) return;

             function checkUnique(email) {
                if (!email) return $q.when(true);

                return ModelService.getModelRelation(scope.student, 'validate-email', {
                    email: email
                }).then(function(data) {
                    if (data) return true;
                    return $q.reject();
                });
            }

            ngModel.$asyncValidators.uniqueEmail = checkUnique;
        },
    };
});